import { render, staticRenderFns } from "./previewCourse.vue?vue&type=template&id=3ddb61a7&scoped=true&"
import script from "./previewCourse.vue?vue&type=script&lang=js&"
export * from "./previewCourse.vue?vue&type=script&lang=js&"
import style0 from "./previewCourse.vue?vue&type=style&index=0&id=3ddb61a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb61a7",
  null
  
)

export default component.exports